import React from "react";
import { Typography, withStyles } from "@material-ui/core";
import classNames from "classnames";
import ReactHtmlParser from "react-html-parser";
import { details as styles } from "../styles";

const Details = ({ poi, classes }) => {
	const { title, tagline, description } = poi;
	return (
		<div className={classes.root}>
			<div className={classes.wrapper}>
				<Typography align="center" className={classes.title}>
					{title}
				</Typography>
				<Typography
					align="center"
					className={classNames(
						classes.subTitle,
						"spacer office-poi-description"
					)}
					variant="h6"
				>
					{tagline}
				</Typography>

				<Typography
					align="center"
					className={classNames(
						classes.subTitle,
						"spacer office-poi-description"
					)}
					variant="h6"
				>
					{ReactHtmlParser(description)}
				</Typography>

				{/*{version.office ? null : (
					<div className={classes.actions}>
						<Fab
							classes={{
								root: classes.btnBig
							}}
							href={`mailto:${manifestJson.project.contacts.email}`}
							target="_top"
							variant="extended"
						>
							{"contactez-nous"}
						</Fab>
					</div>
				)}*/}
			</div>
		</div>
	);
};
export default withStyles(styles)(Details);
